'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { GOOGLE_CAPTCHA_KEY } from './constanses';
export default function RecaptchaWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_CAPTCHA_KEY} scriptProps={{
    async: true,
    defer: true,
    appendTo: 'head'
  }} data-sentry-element="GoogleReCaptchaProvider" data-sentry-component="RecaptchaWrapper" data-sentry-source-file="RecaptchaWrapper.tsx">
      {children}
    </GoogleReCaptchaProvider>;
}